(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_common/handlebar-helpers/assets/javascripts/square-helpers.js') >= 0) return;  svs.modules.push('/components/banner_common/handlebar-helpers/assets/javascripts/square-helpers.js');

'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function registerHelpers(hbs) {
  hbs.registerHelper('getSquareMetaData', function (product, prop) {
    switch (product) {
      case 'svenskaspel-twolines':
        return {
          headerBg: 'bg-red-100',
          bodyBg: 'bg-red-100',
          text: 'fc-navy',
          emblemOutline: false
        }[prop];
      case 'bil-triss':
        return {
          headerBg: 'bg-triss',
          bodyBg: 'bg-triss-200',
          text: 'fc-navy',
          ribbon: 'triss',
          emblemOutline: false
        }[prop];
      case 'dubbel-triss':
        return {
          headerBg: 'bg-triss',
          bodyBg: 'bg-triss-200',
          text: 'fc-navy',
          ribbon: 'triss',
          emblemOutline: false
        }[prop];
      case 'eurojackpot':
        return {
          headerBg: 'bg-eurojackpot',
          bodyBg: 'bg-eurojackpot-200',
          text: 'fc-white',
          ribbon: 'default',
          emblemOutline: false
        }[prop];
      case 'keno':
        return {
          headerBg: 'bg-keno',
          bodyBg: 'bg-keno-200',
          text: 'fc-navy',
          ribbon: 'default',
          emblemOutline: false
        }[prop];
      case 'kenoxpress':
        return {
          headerBg: 'bg-kenoxpress',
          bodyBg: 'bg-kenoxpress-200',
          text: 'fc-navy',
          ribbon: 'default',
          emblemOutline: false
        }[prop];
      case 'lotto':
        return {
          headerBg: 'bg-lotto',
          bodyBg: 'bg-lotto-100',
          text: 'fc-white',
          ribbon: 'default',
          emblemOutline: false
        }[prop];
      case 'lordagsgodis':
        return {
          headerBg: 'bg-game-packages',
          bodyBg: 'bg-game-packages-100',
          text: 'fc-white',
          ribbon: 'lordagsgodis',
          emblemOutline: true
        }[prop];
      case 'mini-triss':
        return {
          headerBg: 'bg-triss',
          bodyBg: 'bg-triss-200',
          text: 'fc-navy',
          ribbon: 'triss',
          emblemOutline: false
        }[prop];
      case 'rubbet':
        return {
          headerBg: 'bg-game-packages',
          bodyBg: 'bg-game-packages-100',
          text: 'fc-white',
          ribbon: 'rubbet',
          emblemOutline: true
        }[prop];
      case 'triss':
        return {
          headerBg: 'bg-triss',
          bodyBg: 'bg-triss-200',
          text: 'fc-navy',
          ribbon: 'triss',
          emblemOutline: false
        }[prop];
      case 'vikinglotto':
        return {
          headerBg: 'bg-vikinglotto',
          bodyBg: 'bg-vikinglotto-200',
          text: 'fc-white',
          ribbon: 'default',
          emblemOutline: false
        }[prop];
      case 'skrap-bingo':
        return {
          headerBg: 'skrapbingo',
          bodyBg: 'bg-skrapbingo-game-background',
          text: 'fc-white',
          ribbon: 'default',
          skrap: true,
          emblemOutline: false,
          labelWidth: 'label-150'
        }[prop];
      case 'skrap-pacman':
        return {
          headerBg: 'skrappacman',
          bodyBg: 'bg-skrappacman-game-background',
          text: 'fc-white',
          ribbon: 'default',
          skrap: true,
          emblemOutline: false,
          labelWidth: 'label-150'
        }[prop];
      case 'skrap-7an':
        return {
          headerBg: 'skrap7an',
          bodyBg: 'bg-skrap7an-game-background',
          text: 'fc-white',
          ribbon: 'default',
          skrap: true,
          emblemOutline: false,
          labelWidth: 'label-150'
        }[prop];
      case 'skrap-keno':
        return {
          headerBg: 'keno',
          bodyBg: 'bg-keno',
          text: 'fc-white',
          ribbon: 'default',
          skrap: true,
          emblemOutline: false,
          labelWidth: 'label-150'
        }[prop];
      case 'skrap-lotto':
        return {
          headerBg: 'lotto-100',
          bodyBg: 'bg-lotto',
          text: 'fc-white',
          ribbon: 'default',
          skrap: true,
          emblemOutline: false,
          labelWidth: 'label-150'
        }[prop];
      case 'skrap-kryss':
        return {
          headerBg: 'skrapkryss',
          bodyBg: 'bg-skrapkryss-game-background',
          text: 'fc-white',
          ribbon: 'default',
          skrap: true,
          emblemOutline: false,
          labelWidth: 'label-150'
        }[prop];
      case 'supportern-neg':
        return {
          headerBg: 'bg-supportern',
          bodyBg: 'bg-supportern-200',
          text: 'fc-white',
          ribbon: 'default',
          emblemOutline: false
        }[prop];
      default:
        return {
          headerBg: 'bg-red',
          bodyBg: 'bg-red-100',
          text: 'fc-navy',
          ribbon: 'default',
          emblemOutline: true
        }[prop];
    }
  });
  hbs.registerHelper('sizedSquareBrandName', function (product, size) {
    if (product === 'eurojackpot') {
      return "".concat(product, "-").concat(size);
    } else if (product === 'kenoxpress') {
      return 'kenoxpress-full';
    } else if (product === 'lordagsgodis') {
      return 'lordagsgodis-oneline';
    }
    return product;
  });
}
if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}

 })(window);